import React from 'react';

/**
 * Full-bleed diagonal brand accent, cyan upper-left field, bright white divide.
 * Covers the entire hero background layer at low opacity so copy stays legible.
 * Sliced rather than stretched, so the diagonal keeps its angle at every hero aspect.
 */
export default function HeroDiagonalAccent() {
  return (
    <svg
      className="absolute inset-0 h-full w-full"
      viewBox="0 0 1000 600"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <filter id="hero-diagonal-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="hero-diagonal-line" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.85" />
          <stop offset="50%" stopColor="#ffffff" stopOpacity="1" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0.85" />
        </linearGradient>
      </defs>

      {/* Cyan field, upper-left triangle above the diagonal */}
      <polygon points="0,0 1000,0 0,600" fill="#00B4FE" fillOpacity="0.11" />

      {/* Bright white glow + crisp divide, bottom-left to top-right */}
      <line
        x1="0"
        y1="600"
        x2="1000"
        y2="0"
        stroke="url(#hero-diagonal-line)"
        strokeWidth="6"
        strokeLinecap="round"
        filter="url(#hero-diagonal-glow)"
        opacity="0.95"
      />
      <line
        x1="0"
        y1="600"
        x2="1000"
        y2="0"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="1"
      />
    </svg>
  );
}
